import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NiveauEtude } from 'src/app/shared/models/niveauEtude';
import { FacadeService } from 'src/app/core/services/facade.service';
import { User } from 'src/app/shared/models/security/user';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { NiveauEtudeModalAjoutComponent } from '../modal/niveauEtude-modal-ajout/niveauEtude-modal-ajout.component';
import { ImportResponse } from 'src/app/shared/models/api-response/import-response';
import { LogService } from 'src/app/core/services/log/log.service';
import { ErrorResponse } from 'src/app/shared/models/api-response/error-response';
import { NiveauEtudeModalDetailComponent } from '../modal/niveauEtude-modal-detail/niveauEtude-modal-detail.component';

export type SortOrder = 'asc' | 'desc';

@Component({
	selector: 'app-list-niveauEtude',
	templateUrl: './list-niveauEtude.component.html',
	styleUrls: ['./list-niveauEtude.component.scss']
})
export class ListNiveauEtudeComponent implements OnInit {
	niveauEtude: NiveauEtude[] = [];
	currentPage = 1;
	itemsPerPage = 10;

	niveauEtudeCsvFile: File = null;
	searchedSkill = '';
	searchedName = '';

	dismissible: true;
	alerts: any[] = [];

	nextWeekNumber: number;

	user: User = null;

	isAddable = false;
	isImportable = false;

	sortType = 'firstName';
	sortOrder: SortOrder = 'asc';

	searchedText: string;

	editNiveauEtudeModalRef: BsModalRef;
	addNiveauEtudeModalRef: BsModalRef;
	screenWidth: number;
	isMobile: boolean = false;

	isListingLoading: boolean = true;

	constructor(
		private router: Router,
		private facade: FacadeService,
		private modalService: BsModalService,
		private logger: LogService
	) {}

	@HostListener('window:resize', ['$event'])
	onWindowResize() {
		this.screenWidth = window.innerWidth;
		if (this.screenWidth < 1200) {
			this.isMobile = true;
		} else {
			this.isMobile = false;
		}
	}

	ngOnInit(): void {
		this.screenWidth = window.innerWidth;
		this.isMobile =
			this.facade.mobileService.isMobile() || this.screenWidth < 1200;

		this.user = this.facade.dataStorageService.getUser();
		this.getNiveauEtude();
		this.isAddable = true;
	}

	getNiveauEtude(): void {
		this.isListingLoading = true;
		this.facade.niveauEtudeService.getAllNiveauEtude().subscribe({
			next: (val) => {
				this.niveauEtude = val.filter((e) => e.name !== 'Sans');
				this.itemsPerPage = this.niveauEtude.length >= 8 ? 10 : 8;

				this.isListingLoading = false;
			},
			error: (err: ErrorResponse) => {
				this.logger.error(err + '');
				this.isListingLoading = false;
				this.niveauEtude = [];
			}
		});
	}

	selectNiveauEtude(niveauEtude: NiveauEtude): void {
		const link = ['/niveauEtude', niveauEtude.id];
		this.router.navigate(link);
	}

	importNiveauEtude(event: any): void {
		this.niveauEtudeCsvFile = event.target.files[0];

		this.facade.niveauEtudeService
			.importNiveauEtude(this.niveauEtudeCsvFile)
			.subscribe({
				next: (importStats: ImportResponse) => {
					this.alerts.push({
						type: 'success',
						msg: `${importStats.entitiesAdded} niveauEtude ont été ajoutés,
                  ${importStats.entitiesBeforeImport} étaient déjà présents.`
					});

					this.getNiveauEtude();
				},
				error: (err) => {
					this.facade.toastService.createHttpErrorToast(
						err.error.message ? err.error.message : '',
						err.status
					);
					this.logger.error(
						'' + err.status + ' ' + err.error.message ? err.error.message : ''
					);
				}
			});
	}

	onClosed(dismissedAlert: any): void {
		this.alerts = this.alerts.filter((alert) => alert !== dismissedAlert);
	}

	openModalAjout() {
		this.facade.authenticationService.checkIsAuthenticated();
		this.addNiveauEtudeModalRef = this.modalService.show(
			NiveauEtudeModalAjoutComponent,
			{
				class: 'modal-lg',
				backdrop: 'static'
			}
		);

		this.addNiveauEtudeModalRef.onHide.subscribe((reason: string | any) => {
			this.getNiveauEtude();
		});
	}

	sortChange(str: string) {
		if (str === this.sortType) {
			if (this.sortOrder === 'asc') {
				this.sortOrder = 'desc';
			} else {
				this.sortOrder = 'asc';
			}
		} else {
			this.sortType = str;
			this.sortOrder = 'asc';
		}
	}

	openModalEdit(niveauEtude: NiveauEtude) {
		const initialState = {
			niveauEtude: niveauEtude
		};
		this.editNiveauEtudeModalRef = this.modalService.show(
			NiveauEtudeModalDetailComponent,
			{
				class: '',
				initialState
			}
		);

		this.editNiveauEtudeModalRef.onHide.subscribe((reason: string | any) => {
			this.getNiveauEtude();
		});
	}
}
